import { useTranslation } from 'react-i18next';
import { getLandingContent } from '@/mocks/landingData';

export default function Footer() {
  const { i18n } = useTranslation();
  const { footer } = getLandingContent(i18n.language);

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="px-6 md:px-10 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div className="lg:col-span-2">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4">
              {footer.company}
            </h3>
            <p className="text-sm text-gray-400 leading-relaxed max-w-md mb-8">
              {footer.description}
            </p>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-md bg-gray-800 flex items-center justify-center">
                  <i className="ri-global-line text-red-500 w-4 h-4 flex items-center justify-center text-sm"></i>
                </div>
                <a href="https://tzk-east.com" rel="nofollow" className="text-sm text-gray-300 hover:text-red-500 transition-colors cursor-pointer">tzk-east.com</a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-md bg-gray-800 flex items-center justify-center">
                  <i className="ri-mail-line text-red-500 w-4 h-4 flex items-center justify-center text-sm"></i>
                </div>
                <span className="text-sm text-gray-300">{footer.email}</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-md bg-gray-800 flex items-center justify-center">
                  <i className="ri-map-pin-line text-red-500 w-4 h-4 flex items-center justify-center text-sm"></i>
                </div>
                <span className="text-sm text-gray-300">{footer.country}</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wide mb-5">
              {footer.navigationTitle}
            </h4>
            <ul className="space-y-3">
              {footer.navigation.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-red-500 transition-colors cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      const target = document.querySelector(link.href);
                      if (target) {
                        target.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wide mb-5">
              {footer.infoTitle}
            </h4>
            <p className="text-xs text-gray-500 leading-relaxed">
              {footer.disclaimer}
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-800">
        <div className="px-6 md:px-10 lg:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">{footer.copyright}</p>
          <p className="text-xs text-gray-600">
            {footer.tagline}
          </p>
        </div>
      </div>
    </footer>
  );
}
